var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.875C6.9604 2.875 2.875 6.9604 2.875 12C2.875 17.0396 6.9604 21.125 12 21.125C17.0396 21.125 21.125 17.0396 21.125 12C21.125 6.9604 17.0396 2.875 12 2.875ZM1.125 12C1.125 5.9939 5.9939 1.125 12 1.125C18.0061 1.125 22.875 5.9939 22.875 12C22.875 18.0061 18.0061 22.875 12 22.875C5.9939 22.875 1.125 18.0061 1.125 12Z",
    fill: "#2D87F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.125 12C1.125 11.5168 1.51675 11.125 2 11.125H22C22.4832 11.125 22.875 11.5168 22.875 12C22.875 12.4832 22.4832 12.875 22 12.875H2C1.51675 12.875 1.125 12.4832 1.125 12Z",
    fill: "#2D87F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8752 12.0003C8.94494 15.1566 10.0477 18.1934 12 20.6519C13.9523 18.1934 15.0551 15.1566 15.1248 12.0003C15.0551 8.84395 13.9523 5.80711 12 3.34866C10.0477 5.80711 8.94494 8.84395 8.8752 12.0003ZM12 2.00028L11.3539 1.41016C8.70962 4.30511 7.20685 8.06203 7.12519 11.9821C7.12494 11.9942 7.12494 12.0064 7.12519 12.0185C7.20685 15.9385 8.70962 19.6954 11.3539 22.5904C11.5197 22.7719 11.7542 22.875 12 22.875C12.2458 22.875 12.4803 22.7719 12.6461 22.5904C15.2904 19.6954 16.7931 15.9385 16.8748 12.0185C16.8751 12.0064 16.8751 11.9942 16.8748 11.9821C16.7931 8.06203 15.2904 4.30511 12.6461 1.41016L12 2.00028Z",
    fill: "#2D87F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/Global.94e19e0342f29f01252b860380d74ab7.svg";
export { ForwardRef as ReactComponent };